import React, { Component } from 'react';
import ReactTable from "react-table";
import "react-table/react-table.css";
import Header from './Header';
import WorkshopModal from '../../../common/components/Workshop';
import { getColumns, getNoDataText, DEFAULTSORTED, DEFAULTPAGESIZE } from './table.conf.js';
import { updateInPath, nullsToStrings, } from '../../../../common/utils';
import { filter } from 'ramda';


class Workshops extends Component {
  constructor(props) {
    super();

    this.state = {
      workshopModal: {
        opened: false,
        data: []
      }
    };
  }

  handleWorkshopModalClose = (refreshData) => {
    this.setState(s => updateInPath(s, 'workshopModal.opened', false));
    if (refreshData) {
      this.props.refresh();
    }
  }

  handleWorkshopModalSave = (data) => {
    this.setState(s => updateInPath(s, 'workshopModal.opened', false));
    this.props.onWorkshopSave(data);
  };

  handleWorkshopModalOpen = ({ workshopId, userId }) => {
    this.props.onWorkshopView(workshopId, userId, (workshop) => {
      this.setState(s => updateInPath(s, 'workshopModal.data', nullsToStrings(workshop)));
      this.setState(s => updateInPath(s, 'workshopModal.opened', true));
    });
  }

  handleWorkshopModalAdd = () => {
    this.setState(s => updateInPath(s, 'workshopModal.data', null));
    this.setState(s => updateInPath(s, 'workshopModal.opened', true));
  }

  handleWorkshopModalDelete = (workshopId, userId) => {
    this.setState(s => updateInPath(s, 'workshopModal.opened', false));
    this.props.onWorkshopDelete(workshopId, userId);
  };

  render() {
    const { data, events } = this.props;
    const workshopModal = this.state.workshopModal;

    // quick hack go show only this year data
    const id2019 = '';
    const data2019 = filter(({event}) => event.id === id2019, data);
    
    return (
      <div>
        { workshopModal.opened && <WorkshopModal
                                    open={workshopModal.opened}
                                    data={workshopModal.data}
                                    events={events}
                                    onSave={this.handleWorkshopModalSave}
                                    onDelete={this.handleWorkshopModalDelete}
                                    onClose={this.handleWorkshopModalClose} />}
        <Header onAdd={this.handleWorkshopModalAdd} />
        <ReactTable
          className='-striped -highlight'
          data={data2019}
          getTrProps={(state, rowInfo, column) => ({
            onClick: e => this.handleWorkshopModalOpen(rowInfo.original)
          })}
          columns={getColumns(this.onRowSelect)}
          defaultSorted={DEFAULTSORTED}
          defaultPageSize={DEFAULTPAGESIZE}
          noDataText={getNoDataText()}
        />
      </div>
    );
  };
};

export default Workshops;



// WEBPACK FOOTER //
// ./src/private/user/components/Workshops/index.js